import React from "react";
import withStyles from "react-jss";
import { RatingStar } from "ComponentsUI/RatingsViews";
import LazyImage from "ComponentsUI/Image";

const styles = (theme) => ({
	root: {
		width: "100%",
		"&:hover": {
			"& $popup": {
				opacity: "1",
				visibility: "visible",
			},
		},
	},
	item: {
		display: "block",
		width: "auto",
		maxWidth: "100%",
		maxHeight: "40px",
		boxSizing: "border-box",
		margin: "0 auto",
	},
	popup: {
		position: "absolute",
		visibility: "hidden",
		left: "-1px",
		right: "-1px",
		bottom: "99px",
		maxHeight: "calc(100% - 100px)",
		display: "flex",
		flexDirection: "column",
		transition: "opacity ease 0.25s",
		backgroundColor: "#ffffff",
		zIndex: "9",
		padding: "30px 20px 25px",
		opacity: "0",
		border: `1px solid ${theme.palette.colors.disabled}`,
	},
	popupItem: {
		maxWidth: "100%",
		maxHeight: "71px",
		backgroundSize: "contain",
		alignSelf: "center",
		backgroundPosition: "50% 50%",
		backgroundRepeat: "no-repeat",
		boxSizing: "border-box",
		marginBottom: "20px",
		flexShrink: "100",
	},
	subheader: {
		fontFamily: theme.fonts.light,
		fontSize: "12px",
		lineHeight: "1",
		textAlign: "center",
		color: "white",
	},
	rating: {
		fontSize: 0,
		lineHeight: 0,
		width: "100%",
		textAlign: "center",
		"& span": {
			color: theme.palette.colors.purplishBlue,
			fontSize: "18px",
		},
	},
	withoutRating: {
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: 0.71,
		letterSpacing: "2px",
		color: theme.palette.colors.disabled,
		textTransform: "uppercase",
	},
	reviews: {
		marginTop: "15px",
		textAlign: "center",
		cursor: "pointer",
		"& span:first-child": {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.43",
			letterSpacing: "2px",
			color: theme.palette.colors.purplishBlue,
			textTransform: "uppercase",
			display: "inline-block",
			verticalAlign: "top",
			marginRight: "6px",
		},
		"& span:last-child": {
			fontFamily: theme.fonts.medium,
			fontSize: "12px",
			lineHeight: "0.83",
			color: theme.palette.colors.purplishBlue,
			display: "inline-block",
			verticalAlign: "top",
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		popup: {
			padding: "30px 45px 25px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		popup: {
			display: "none",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			padding: 0,
			width: "auto",
		},
		popup: {
			display: "none",
		},
		rating: {
			"& svg": {
				width: "13px",
				height: "13px",
			},
		},
	},
});

const Component = ({
	name = "Name",
	reviewsCounter = 0,
	rating = 0,
	showLogo = true,
	classes,
	items = ["http://static.101internet.ru/images/404.png"],
	onReviewClick = () => {},
	text,
	webpTransformer,
}) => {
	const preventBehavior = (e) => {
		e.stopPropagation();
	};

	const generateSlides = (items, className) => {
		return items.map((item, index) => {
			return (
				<LazyImage
					src={!!webpTransformer ? webpTransformer(item) : item}
					className={className}
					alt={item.name}
					key={index}
				/>
			);
		});
	};

	return (
		<div className={classes.root} onClick={preventBehavior}>
			<LazyImage
				src={!!webpTransformer ? webpTransformer(items[0]) : items[0]}
				className={classes.item}
				alt={name}
			/>
			<div className={classes.popup}>
				{generateSlides(items, classes.popupItem)}
				<div className={classes.rating}>
					{!!rating ? (
						<RatingStar tariff={true} rating={rating} />
					) : (
						<div className={classes.withoutRating}>{text.NO_RATING}</div>
					)}
				</div>
				<div onClick={onReviewClick} className={classes.reviews}>
					<span>{text.REVIEWS}</span>
					<span>{reviewsCounter}</span>
				</div>
			</div>
		</div>
	);
};

const ProviderLogo = withStyles(styles)(Component);
ProviderLogo.displayName = "ProviderLogo";

export default ProviderLogo;
